export default __webpack_public_path__ + "static/media/pag2.1521bdd4.jpg";